import { render } from "./DeckSidebar.vue?vue&type=template&id=08cd79c7&scoped=true"
import script from "./DeckSidebar.vue?vue&type=script&lang=js"
export * from "./DeckSidebar.vue?vue&type=script&lang=js"

import "./DeckSidebar.vue?vue&type=style&index=0&id=08cd79c7&lang=css"
import "./DeckSidebar.vue?vue&type=style&index=1&id=08cd79c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cd79c7"]])

export default __exports__